import { useTranslation } from "react-i18next";
import { Slider, styled, Tooltip } from "@mui/material";

const SliderWrapper = styled("div")({
  height: "100px",
  width: "30px",
  backgroundColor: "rgba(255, 255, 255, 0.667)",
  borderRadius: "8px",
  padding: "16px 4px",
  "& .slider": {
    padding: "0 10px",
  },
  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
});

const OpacitySlider = ({ opacity, onChange }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t("SingleFieldPage.GroundConditions.Opacity")}
      placement="right"
    >
      <SliderWrapper>
        <Slider
          value={opacity}
          orientation="vertical"
          min={0}
          max={100}
          step={1}
          onChange={onChange}
          aria-label={t("SingleFieldPage.GroundConditions.Opacity")}
          size="small"
          valueLabelDisplay="auto"
          className="slider"
        />
      </SliderWrapper>
    </Tooltip>
  );
};

export default OpacitySlider;
